<template>
  <!-- 题库中心-最外层容器 -->
  <div class="page">
    <!-- 轮播图 -->
    <div class="swiper">
      <el-carousel
        class="carousel"
        :interval="5000"
        :height="autoHeight"
        indicator-position="none"
      >
        <el-carousel-item v-for="item of bannerList" :key="item.id">
          <el-row>
            <el-col :span="24">
              <div class="wrapper">
                <el-image class="swiper-img" :src="item.img_url"></el-image>
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
    <ownQuestion />
  </div>
</template>

<script>
import ownQuestion from './commonExam/own-question'

import { api_getSchoolBannerList } from '@/api/competitionCenter'

export default {
  name: 'CompetitionCenter-QuestionBankCenter-Campus',
  components: {
    ownQuestion,
  },
  data: () => ({
    bannerList: [], //社区轮播图
    autoHeight: '0px', //轮播图自适应高度
  }),
  mounted() {
    this.getAutoHeight()
    this.getSchoolBannerList()
  },
  methods: {
    //轮播图自适应高度
    getAutoHeight() {
      let _w = document.documentElement.clientWidth || document.body.clientWidth
      let _h = _w * 0.196
      this.autoHeight = (_h > 300 ? 300 : _h) + 'px'
    },
    //获得社区轮播图
    getSchoolBannerList() {
      api_getSchoolBannerList({
        banner_type: 2,
      }).then((res) => {
        console.log('获取校区轮播图')
        console.log(res)
        this.bannerList = res.bannerList
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.swiper {
  padding: 10px 10px 0;
  .carousel {
    max-width: 1680px;
    margin: auto;

    /deep/ .el-carousel__container {
      .el-carousel__item {
        height: 100%;

        .el-row {
          height: 100%;

          .el-col {
            height: 100%;

            .wrapper {
              height: 100%;

              .el-image {
                height: 100%;
              }
            }
          }
        }
      }

      .el-carousel__arrow {
        display: none;
        width: 3vw;
        height: 3vw;
        font-size: 28px;
        font-weight: bold;

        &:hover {
          color: #fff304;
        }
      }
    }

    .wrapper {
      width: 100%;
      // height: 0;
      // padding-bottom: 29.6%;

      .swiper-img {
        width: 100%;
        border-radius: 10px;
      }
    }
  }
}
</style>
